import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { actions } from '../../modules/Actions';

export interface LocationHistoryState {
  pathNames: string[];
}

export const initialData: LocationHistoryState = {
  pathNames: [],
};

export const LocationHistoryReducer = reducerWithInitialState(initialData)
  .case(actions.locationHistory.updatePathName, (state: LocationHistoryState, payload: string) => {
    return { ...state, pathNames: [...state.pathNames, payload] };
  })
  .case(actions.locationHistory.resetData, (state: LocationHistoryState) => {
    return { ...state, pathNames: [] };
  });
